import { ListActionsAudit } from 'domain/usecases/audit/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteListActionsAudit implements ListActionsAudit {
  private readonly url: string;

  private readonly httpClient: HttpClient<ListActionsAudit.Model>;

  constructor(url: string, httClient: HttpClient<ListActionsAudit.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  listActions = async (
    params: ListActionsAudit.Params,
  ): Promise<ListActionsAudit.Model> => {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}`,
      body: params.body,
      method: 'post',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
